<template>
    <transition name="container-transitions" mode="out-in">
        <div v-if="show">
            <div class="background kt-grid kt-grid--ver kt-grid--root kt-page">
                <div class="kt-grid kt-grid--hor kt-grid--root  kt-login kt-login--v4 kt-login--signin" id="kt_login">
                    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                        <div class="kt-grid__item kt-grid__item--fluid kt-login__wrapper">
                            <div class="kt-login__container">
                                <div class="kt-login__logo">
                                    <a href="#">
                                        <img :src="loginImage" class="img-fluid" style="max-height: 200px">
                                    </a>
                                </div>
                                <div class="kt-login__signin">
                                    <div class="kt-login__head">
                                        <h2 class="kt-login__title">{{ $t('AppChangePassword.Troca de senha') }}</h2>
                                    </div>
                                    <form class="kt-form" v-on:submit.prevent>
                                        <div class="input-group">
                                            <app-input class="form-control" type="password" :placeholder="$t('AppChangePassword.Nova Senha')"
                                                       v-model="form.password"
                                                       :class="{'is-invalid' : $v.form.password.$invalid && $v.form.password.$dirty}">
                                            </app-input>
                                            <span class="form-text error"
                                                  v-if="$v.form.password.$invalid && $v.form.password.$dirty">
                                            {{
                                                    $t('AppChangePassword.A senha deve possuir entre 8 e 64 caracteres e ao menos um caracter maiúsculo, um minúsuclo e um caracter especial')
                                                }}
                                        </span>
                                        </div>
                                        <div class="input-group">
                                            <app-input class="form-control" type="password" :placeholder="$t('AppChangePassword.Confirmar Nova Senha')"
                                                       v-model="form.passwordConfirm"
                                                       :class="{'is-invalid' : $v.form.passwordConfirm.$invalid && $v.form.passwordConfirm.$dirty}">
                                            </app-input>
                                            <span class="form-text error"
                                                  v-if="$v.form.passwordConfirm.$invalid && $v.form.passwordConfirm.$dirty">
                                              {{ $t('AppChangePassword.Senhas não conferem') }}
                                        </span>
                                        </div>
                                        <div class="kt-login__actions text-center">
                                            <app-button type="primary" size="lg" @handleClick="validateForm">
                                                {{ $t('AppChangePassword.Alterar') }}
                                            </app-button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import AppButton from '@/components/common/AppButton.vue'
import AppInput from '@/components/common/AppRegisterInput.vue'

import {router} from '@/router';
import axios from "axios";
import {helpers, required, sameAs} from "vuelidate/lib/validators";

// "Maximum password length should be at least 64 characters to allow passphrases" - OWASP Cheat Sheet Series
const MAX_PASSWORD_LENGTH = 64;
const MIN_PASSWORD_LENGTH = 8;
const SPECIAL_CHARACTERS = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
const LOWER_CASE = /[a-z]/;
const UPPER_CASE = /[A-Z]/;
const passwordValidation = helpers.withParams(
    { type: 'passwordValidation' },
    value => {
        const hasRequiredLength = MIN_PASSWORD_LENGTH <= value.length && value.length <= MAX_PASSWORD_LENGTH;
        const hasSpecialCharacter = SPECIAL_CHARACTERS.test(value);
        const hasLowerCaseCharacter = LOWER_CASE.test(value);
        const hasUpperCaseCharacter = UPPER_CASE.test(value);

        return hasRequiredLength && hasSpecialCharacter && hasLowerCaseCharacter && hasUpperCaseCharacter;
    }
);

export default {
    mounted() {
        this.fade();
        if (this.$route.params.token) {
            this.token = this.$route.params.token;
        }
    },
    beforeDestroy() {
        this.fade();
    },
    data() {
        return {
            themeActive: process.env.VUE_APP_THEME_ACTIVE,
            loginImage: require("../../../assets/images/brands/" + process.env.VUE_APP_THEME_IMAGE + ".png"),
            show: false,
            locale: navigator.language || navigator.userLanguage,
            form: {
                password: null,
                passwordConfirm: null,
            },
            token: null
        }
    },
    components: {AppButton, AppInput},
    methods: {
        fade() {
            this.show = !this.show;
        },
        validateForm() {
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppChangePassword.Senhas não conferem'),
                    detail: this.$t('AppChangePassword.Informe a mesma senha nos dos campos'),
                    life: 3000
                });
                return;
            }

            this.changePassword();
        },
        changePassword() {
            axios.post(process.env.VUE_APP_BACKEND_ADDRESS + '/auth/v1/change-password', {
                token: this.token,
                password: this.form.password
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                    if (response.status === 200) {
                        this.$toast.add({
                            severity: 'success',
                            summary: this.$t('AppChangePassword.Senha alterada'),
                            detail: this.$t('AppChangePassword.A senha foi alterada com sucesso, efetue o login usando a nova senha'),
                            life: 5000
                        });
                        router.push({name: 'login'});
                    }
                }
            ).catch(() => {
                this.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppChangePassword.Senha não alterada'),
                    detail: this.$t('AppChangePassword.Não foi possível alterar a senha'),
                    life: 3000
                });
            });
        }
    },
    validations: {
        form: {
            password: {required, passwordValidation},
            passwordConfirm: {required, sameAsPassword: sameAs('password')},
        }
    }
}
</script>

<style scoped>
@import "../../../assets/styles/login-4.css";

.container-transitions-enter-active {
    transition-duration: 2.1s !important;
    transition-property: opacity !important;
    transition-timing-function: ease !important;
}

.container-transitions-enter, .container-transitions-leave-active {
    opacity: 0 !important;
}

</style>
